import gql from "graphql-tag";

export const INSERT_REFERRAL_INVITES = gql`
  mutation insert_referral_invite_csv_one(
    $file_name: String
    $file_path: String
  ) {
    insert_referral_invite_csv_one(
      object: { file_name: $file_name, file_path: $file_path }
    ) {
      id
    }
  }
`;
